module.exports = __webpack_public_path__ + "static/512-512-9ca0a675363d8521cc871b0faa79f794.png";